<template>
    <section id="checklists">
        <template v-if="this.$props.filter">
            <header>
                <section>
                    <label v-for="tag in allTags" class="tag" :style="{backgroundColor: tag.color}">
                        {{tag.name}} <input type="checkbox" :value="tag.id" v-model="activeTags"/>
                    </label>
                </section>
            </header>
            <hr>
        </template>
        <template v-for="checklist in checklists" >
            <ChecklistItem :checklist="checklist" v-show="checklistHasActiveTags(checklist)"/>
        </template>
    </section>
</template>

<script>
import ChecklistItem from '@/components/checklist_item.vue'

export default {
    name: 'Checklists',
    props: [
        'token',
        'userSlug',
        'filter',
    ],
    components: {
        ChecklistItem,
    },
    data: function(){
        return {
            fallbackTag: {
                id: "vue_fallback_tag",
                name: "🥚 (No Category)"
            },
            checklists: [],
            activeTags: []
        }
    },
    methods: {
        showAllTags: function() {
            this.allTags.forEach(tag => this.activeTags.push(tag.id));
        },
        checklistHasActiveTags: function(checklist) {
            let hasActiveTags = false
            checklist.tags.forEach(tag => {
                if (this.activeTags.includes(tag.id) == true) {
                    hasActiveTags = true;
                }
            })
            return hasActiveTags
        }
    },
    computed: {
        allTags: function() {
            // Note: JSON.stringify/parse is a workaround to make the set work with objects
            const allTags_stringified = new Set()
            const allTags = []
            this.checklists.forEach(checklist => {
                // Add fallback tag if list has no tags
                if (checklist.tags.length == 0) {
                    checklist.tags.push(this.fallbackTag)
                }
                checklist.tags.forEach(tag => allTags_stringified.add(JSON.stringify(tag)));
            });
            allTags_stringified.forEach(stringifiedTag => allTags.push(JSON.parse(stringifiedTag)))

            return allTags
        }
    },
    mounted() {
        let useToken = process.env.VUE_APP_API_TOKEN;
        if (this.$props.token) {
            useToken = this.$props.token;
        }

        let url = `${process.env.VUE_APP_API_ROOT}/api/checklist/checklists/?detail=1`;
        if (this.$props.userSlug) {
            url = `${process.env.VUE_APP_API_ROOT}/api/checklist/checklists/?detail=1&user_slug=${this.$props.userSlug}`;
        }

        fetch(url, {
            method: "GET",
            headers: {
                Authorization: `token ${useToken}`
            }
        })
            .then(response => response.json())
            .then(data => {
                this.checklists = data;
                this.showAllTags();
            })
            .catch(error => console.log(error))
    }
}
</script>